<template>
  <div id="macna-surveys">
    <v-container>
      <v-layout>
        <v-flex>
            <survey-card-list :title="surveyTitle"></survey-card-list>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import SurveyCardList from '../../../components/lists/SurveyCardList'

export default {
  data () {
    return {
      surveyTitle: 'Survey Results - MACNA 2018'
    }
  },
  components: {'survey-card-list': SurveyCardList}
}
</script>



// WEBPACK FOOTER //
// src/layouts/marketing/charts/MACNAsurveys.vue